var _path, _ellipse, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg9Mobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_9mobile_Logo",
    "data-name": "9mobile Logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.516,
    height: 39.087,
    viewBox: "0 0 22.516 39.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M223.06,50.6a1.629,1.629,0,0,1,1.126.326,1.315,1.315,0,0,1,.356,1.015V54.4h-.77V52.048q0-.778-.873-.778a1.325,1.325,0,0,0-.711.2,1.913,1.913,0,0,1,.052.474V54.4h-.77V52.048q0-.778-.873-.778a2.226,2.226,0,0,0-.777.141V54.4h-.77V50.989a3.393,3.393,0,0,1,.8-.28,4.111,4.111,0,0,1,.905-.107,1.7,1.7,0,0,1,1.071.28A2.848,2.848,0,0,1,223.06,50.6Zm4.12,3.914a1.669,1.669,0,0,1-1.324-.5,2.159,2.159,0,0,1-.443-1.467q0-1.949,1.761-1.948a1.7,1.7,0,0,1,1.334.5,2.552,2.552,0,0,1-.014,2.908A1.679,1.679,0,0,1,227.18,54.517Zm-.008-.66q1.012,0,1.012-1.311a1.626,1.626,0,0,0-.24-.974.9.9,0,0,0-.77-.323.869.869,0,0,0-.766.33,2.126,2.126,0,0,0,.007,1.941.858.858,0,0,0,.757.335Zm4.354-3.252a1.55,1.55,0,0,1,1.246.5,2.1,2.1,0,0,1,.426,1.406,2,2,0,0,1-.51,1.552,1.878,1.878,0,0,1-1.3.457q-1.577,0-1.577-.845V49.2h.763v1.639a2.289,2.289,0,0,1,.48-.167,2.071,2.071,0,0,1,.465-.064Zm-.191,3.238a.948.948,0,0,0,.841-.348,1.662,1.662,0,0,0,.24-.956,1.524,1.524,0,0,0-.253-.948.891.891,0,0,0-.751-.326,1.788,1.788,0,0,0-.429.055,1.506,1.506,0,0,0-.4.16v2q0,.36.753.36Zm2.734-4.453h.821v.7h-.821Zm.022,1.319h.77l.007,3.7h-.777Zm1.861,3.7V49.277h.763V54.4Zm3.342-3.811a1.438,1.438,0,0,1,1.258.56,2.631,2.631,0,0,1,.392,1.567h-2.582a1.264,1.264,0,0,0,.32.834,1.079,1.079,0,0,0,.8.285,2.464,2.464,0,0,0,1.188-.3v.726a3.2,3.2,0,0,1-1.31.254,1.692,1.692,0,0,1-1.3-.508,2.033,2.033,0,0,1-.473-1.441,2.145,2.145,0,0,1,.447-1.463A1.6,1.6,0,0,1,239.3,50.595Zm-.022.64a.85.85,0,0,0-.608.208,1.162,1.162,0,0,0-.286.7h1.782a1.151,1.151,0,0,0-.264-.692A.834.834,0,0,0,239.273,51.235Zm-7.355-30.481a8.875,8.875,0,0,0-1.961-.315,6.164,6.164,0,1,0,6.011,4.691l4.92-1.325a11.171,11.171,0,0,1-1.467,8.975l-8.147,15.105h-7.548L229.089,38c.029-.054-.057-.175-.129-.181a11.219,11.219,0,1,1,4.392-21.881Z",
    transform: "translate(-218.74 -15.43)",
    fill: "#006e53",
    fillRule: "evenodd"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 3.392,
    cy: 3.392,
    rx: 3.392,
    ry: 3.392,
    transform: "translate(7.788 7.784)",
    fill: "#d6e806"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M568.622,53.832a6.15,6.15,0,0,0-3.162-3.315m5.321,2.39a8.745,8.745,0,0,0-4.394-4.626m6.476,3.932A10.936,10.936,0,0,0,567.08,46.2",
    transform: "translate(-551.583 -44.968)",
    fill: "none",
    stroke: "#d6e806",
    strokeLinecap: "round",
    strokeWidth: 1.26
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg9Mobile);
export default __webpack_public_path__ + "static/media/9mobile.e4f9ecd8855398ef7cab371ee3ed71c2.svg";
export { ForwardRef as ReactComponent };